webpackJsonp([4],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_03_bg.png?d80ae75907af52625a259209cdd53c94";

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-margin-bottom"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("biz_title")) + " - "), _c('span', [_vm._v("商业IP")])]), _vm._v(" "), _c('div', {
    staticClass: "tx-page-subtitle"
  }, [_vm._v("专注于街区式商业物业投资与运营")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-style"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "projects.html",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "imgs/business/zyyw_ip2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 info-style"
  }, [_c('h4', [_vm._v("专注商街，共生烟火")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text_jj"
  }, [_vm._v("专注于特色商业街区，一般规模在2-3万㎡，通过前期策划、工程改造，品牌导入，运营推广等方式，创造风格鲜明的主题场景，打造以“交往”与“我们”为内涵的体验式商街。与商家共成长，与社区共呼吸，与业主共未来。")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text_a"
  }, [_c('a', {
    attrs: {
      "href": "projects.html",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")])])]), _vm._v(" "), _c('video', {
    staticClass: "video_xj",
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/business/gbwh_mp4bg.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/business/gbwh_mp4.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-style",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "src": "imgs/business/gbwh1.jpg"
    }
  })])
}]}

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/zyyw_bg.jpg?aa8df198ddcd5756ddcf74eecd2c7c0d";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(71);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(7)("634f84bf", content, true);

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

var Vue = __webpack_require__(3);
var VueI18n = __webpack_require__(0);
Vue.use(VueI18n);

//import nls
var nls = __webpack_require__(4);
var defaultLocale = localStorage.getItem("defaultLocale");
if (defaultLocale == null) {
    defaultLocale = nls.defaultLocale;
}
var i18n = new VueI18n({
    locale: defaultLocale, // set locale
    messages : nls.text, // set locale messages
});

// 获取组件引用
// var testC = require('./components/App.vue');
var header_comp = __webpack_require__(2);
var body_comp = __webpack_require__(19);
var footer_comp = __webpack_require__(1);

window.vm = new Vue({
    i18n : i18n,  // VueI18n 插件
    el:"#app",
    components: {
        header_comp: header_comp,
        body_comp: body_comp,
        footer_comp: footer_comp
    }
});




/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(107),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


module.exports = {
    computed: {
        pan_height_line1: function () {
            return {
                pan_height_line1_zh: this.$i18n.locale != 'en_US',
                pan_height_line1_en: this.$i18n.locale == 'en_US'
            };
        },
        pan_height_line2: function () {
            return {
                pan_height_line2_zh: this.$i18n.locale != 'en_US',
                pan_height_line2_en: this.$i18n.locale == 'en_US'
            };
        }
    },
    mounted: function () {

        $('#fundCert').viewer({
            scalable: false,
            navbar: false,
            title: false,
            toolbar: false,
            url: 'data-original'
        });
        window.pageTitle = {
            en_US: this.$i18n.messages.en_US.page_title_business,
            zh_HK: this.$i18n.messages.zh_HK.page_title_business,
            zh_CN: this.$i18n.messages.zh_CN.page_title_business
        };
        window.setTitle(window.pageTitle[this.$i18n.locale]);
    }

};

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "body,html{position:relative;height:100%;font-size:12px}.swiper-container{width:100%;height:100%}body:after{background-image:url(" + __webpack_require__(13) + ");background-repeat:no-repeat;background-size:cover}.pan_height_line1_zh{height:auto}@media (min-width:992px){.pan_height_line1_zh{height:360px}}@media (min-width:1200px){.pan_height_line1_zh{height:340px}}.pan_height_line1_en{height:auto}@media (min-width:992px){.pan_height_line1_en{height:360px}}@media (min-width:1200px){.pan_height_line1_en{height:340px}}.pan_height_line2_zh{height:auto}@media (min-width:992px){.pan_height_line2_zh{height:220px}}@media (min-width:1200px){.pan_height_line2_zh{height:220px}}.pan_height_line2_en{height:auto}@media (min-width:992px){.pan_height_line2_en{height:220px}}@media (min-width:1200px){.pan_height_line2_en{height:220px}}.container-margin-bottom{margin-bottom:10px}@media (min-width:768px){.container-margin-bottom{margin-bottom:60px}}.pan-num{text-align:center;font-size:80px;color:#d3a571;padding-left:20px;padding-top:25px}@media (min-width:768px){.pan-num{font-size:144px;padding-top:0}}.pan-num-size{width:80px}@media (min-width:768px){.pan-num-size{width:130px}}@media (min-width:992px){.pan-num-size{width:130px}}@media (min-width:1200px){.pan-num-size{width:150px}}.pan-01-wrapper{padding:0 0 30px}@media (min-width:768px){.pan-01-wrapper{padding:0 0 30px}}@media (min-width:992px){.pan-01-wrapper{padding:0 45px 30px 0}}@media (min-width:1200px){.pan-01-wrapper{padding:0 45px 30px 0}}.pan-01{background:#fff;background-image:url(" + __webpack_require__(8) + ");background-position-x:right;background-position-y:top;background-repeat:no-repeat;background-size:20% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-01{background-size:15% auto}}@media (min-width:992px){.pan-01{background-size:30% auto}}.pan-01b-size{width:70%}@media (min-width:768px){.pan-01b-size{width:80%}}@media (min-width:992px){.pan-01b-size{width:70%}}.pan-01-detail-size{width:85%}@media (min-width:768px){.pan-01-detail-size{width:85%}}@media (min-width:992px){.pan-01-detail-size{width:70%}}.pan-02-wrapper{padding:0 0 30px}.pan-02{background:#fff;background-image:url(" + __webpack_require__(9) + ");background-position-x:right;background-position-y:bottom;background-repeat:no-repeat;background-size:20% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-02{background-size:20% auto}}@media (min-width:992px){.pan-02{background-size:28%}}@media (min-width:1200px){.pan-02{background-size:auto}}.pan-02b-size{width:70%}@media (min-width:768px){.pan-02b-size{width:80%}}@media (min-width:992px){.pan-02b-size{width:65%}}@media (min-width:1200px){.pan-02b-size{width:60%}}.pan-02-detail-size{width:85%}@media (min-width:768px){.pan-02-detail-size{width:80%}}@media (min-width:992px){.pan-02-detail-size{width:68%}}@media (min-width:1200px){.pan-02-detail-size{width:65%}}.pan-03-wrapper{padding:0 0 30px}@media (min-width:768px){.pan-03-wrapper{padding:0 0 30px}}@media (min-width:992px){.pan-03-wrapper{padding:0 0 30px}}@media (min-width:1200px){.pan-03-wrapper{padding:0 0 30px}}.pan-03{background:#fff;background-image:url(" + __webpack_require__(10) + ");background-position-x:right;background-position-y:bottom;background-repeat:no-repeat;background-size:25% auto;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}@media (min-width:768px){.pan-03{background-size:28% auto}}@media (min-width:992px){.pan-03{background-size:31% auto}}@media (min-width:1200px){.pan-03{background-size:33% auto}}.pan-03b-size{width:70%}@media (min-width:768px){.pan-03b-size{width:75%}}@media (min-width:992px){.pan-03b-size{width:75%}}@media (min-width:1200px){.pan-03b-size{width:80%}}.pan-03-detail-size{width:80%}@media (min-width:768px){.pan-03-detail-size{width:70%}}@media (min-width:992px){.pan-03-detail-size{width:70%}}@media (min-width:1200px){.pan-03-detail-size{width:65%}}.pan-04-wrapper{padding:0 0 30px}.pan-04{background:RGBA(0,0,0,.5)}.list-style,.pan-04{box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.list-style{display:flex;flex-wrap:wrap;align-items:center;padding:10px 20px 20px;margin:0 0 20px;background-color:#fff}@media (min-width:992px){.list-style{margin:0 20px 20px}}.list-style .text_jj{padding:10px 0;font-size:16px;color:#666;text-align:justify}.list-style .text_a{display:inline-block;margin:0;padding:0}.list-style .text_a a{display:inline-block;padding:4px 10px;margin-top:10px;background-color:#ffc000;color:#222;font-size:16px;line-height:normal}.video_xj{display:block;width:100%;margin-top:20px}.info-style h4{display:block;margin-bottom:0;font-weight:700;font-size:24px;color:#f29603}", ""]);

// exports


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_01_bg.png?3ef0485f5999dcbf2922507024d4622e";

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/biz_content_02_bg.png?b7c3375f8da4b407281b6eca62a5efd4";

/***/ })

},[152]);


// WEBPACK FOOTER //
// js/business_two.bundle.js?133f1f94704790619d91